import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConstantsCLA {
  public static URL_BACK_END_CLA = environment.BE_BASE_URL;
  public static URL_PLACEMENT =
    'http://160.97.104.65/place/public/code/tce_user_registration.php';
  public static CREA_LANGUAGE_LEVEL_URL = 'api/language-levels/crea';
  public static MODIFICA_LANGUAGE_LEVEL_URL = 'api/language-levels/modifica';
  public static ELIMINA_LANGUAGE_LEVEL_URL = 'api/language-levels/elimina';
  public static GET_LANGUAGE_LEVEL_URL = 'api/language-levels/get';
  public static SEARCH_LANGUAGE_LEVEL_URL = 'api/language-levels/search';
  public static TUTORS_SEARCH_URL = 'api/utente/search';
  public static SEND_EMAIL_URL = 'api/email/send';
  public static GET_TUTOR_URL = 'api/utente/get';
  public static CATEGORY_SELF_STUDY_URL = '/api/self-study/search-category';
  public static DOCUMENT_SELF_STUDY_URL =
    '/api/self-study/search-self-study-document';
  public static GET_REGISTRAZIONE_SISTEMA_URL = 'api/registrazione-sistema/get';
  public static REGISTER_URL = 'api/login/registrazione';
  public static REGISTER_PLACEMENT_URL = 'api-placement/registrazione/register';
  public static CORSI_LAUREA_COMBO_URL = 'api/select/corsoLaurea';
  public static DOWNLOAD_DOCUMENT_SESSIONE_OLA =
    'api/sessione-ola/download-doc';
  public static SESSIONE_OLA_ACTIVE_URL = 'api/sessione-ola/get-active';
  public static ELIMINA_URL = 'api/prenotati-prova-finale/elimina';
  public static ELIMINA_GRUPPO_STUDIO_URL = 'api/gruppo-studio/elimina';
  public static SEARCH_URL = 'api/prenotati-prova-finale/search';
  public static TUTORS_COMBO_URL = 'api/select/tutors';
  public static LABORATORI_COMBO_URL = 'api/select/laboratori';
  public static PRENOTAZIONE_LABORATORIO_SEARCH_URL =
    'api/prenotazione-laboratorio/search';
  public static CREA_PRENOTAZIONE_LABORATORIO =
    'api/studente-prenotazione-laboratorio-tutoraggio/crea';
  public static VERIFICA_PRENOTAZIONE_LABORATORIO =
    'api/studente-prenotazione-laboratorio-tutoraggio/verifica-prenotazioni';
  public static MODIFICA_URL = '/api/profilo/modifica';
  public static GET_FOTO_PROFILO_URL = '/api/profilo/get-foto-profilo';
  public static ELIMINA_PRENOTAZIONE_LABORATORIO_URL =
    '/api/studente-prenotazione-laboratorio-tutoraggio/elimina';
  public static SEARCH_PRENOTAZIONE_LABORATORIO_URL =
    '/api/studente-prenotazione-laboratorio-tutoraggio/search';
  public static INSTRUCTORS_SEARCH_URL = 'api/utente/search';
  public static GET_INSTRUCTOR_URL = 'api/utente/get';
  public static ESITO_PLACEMENT_TEST_URL = 'api/home/esitoPlacementTest';
  public static PERCENTUALI_STUDIO_URL = 'api/home/percentualiStudio';
  public static GET_AGENDA_STUDIO_STUDENTE_URL =
    'api/studente/get-agenda-studio';
  public static ABILITA_ORALE_FACOLTATIVO_STUDENTE_URL =
    'api/studente/abilita-orale-facoltativo';
  public static PROVE_ESAMI_DISPONIBILI =
    'api/prova-finale/prove-esami-disponibili';
  public static ADD_PRENOTAZIONE_PROVA_FINALE =
    '/api/prenotati-prova-finale/crea';
  public static INSTRUCTORS_COMBO_URL = 'api/select/instructors';
  public static STUDENTI_COMBO_URL = 'api/select/studenti';
  public static GET_GRUPPO_URL = 'api/gruppo-studio/get';
  public static I_MIEI_LABORATORI_URL =
    'api/dashboard-tutor/get-miei-laboratori';
  public static GET_AGENDE_DA_VERIFICARE =
    'api/dashboard-tutor/get-totale-agende-da-verificare';
  public static I_MIEI_GRUPPI_STUDIO_URL =
    'api/dashboard-instructor/get-miei-gruppi-studio';
  public static CREA_UTENTE_URL = 'api/utente/crea';
  public static MODIFICA_UTENTE_URL = 'api/utente/modifica';
  public static GRUPPO_COMBO_URL = 'api/select/gruppi';
  public static UTENTI_SEARCH_URL = 'api/utente/search';
  public static GET_UTENTE_URL = 'api/utente/get';
  public static ABILITA_DISABILITA_URL = 'api/utente/abilita-disabilita';
  public static MODIFICA_STUDENTE_OLA_URL = 'api/studente/modifica';
  public static MODIFICA_PWD_STUDENTE_OLA_URL = 'api/studente/reset-pwd';
  public static CREA_STUDENTE_OLA_URL = 'api/studente/crea';
  public static STUDENTI_SEARCH_URL = 'api/studente/search';
  public static STUDENTI_ADD_ORA_LABORATORIO_URL =
    'api/studente/add-ora-laboratorio';
  public static STUDENTI_PRENOTATI_PROVA_FINALE_SEARCH_URL =
    'api/prenotati-prova-finale/search-studenti-prenotati-volte';
  public static STUDENTI_PROVA_FINALE_NON_SUPERATA_SEARCH_URL =
    'api/voti-prova-finale-studente/studenti-prova-finale-non-superata-volte';
    public static STUDENTI_STORICO_PROVA_FINALE_SEARCH_URL =
    'api/voti-prova-finale-studente/studenti-storico-prova-finale';
  public static GET_STUDENTE_URL = 'api/studente/get';
  public static SESSIONI_OLA_COMBO_URL = 'api/select/sessioni-ola';
  public static GRUPPI_STUDIO_COMBO_URL = 'api/select/gruppi-studio';
  public static GET_LABORATORIO_PRESENZE_URL =
    'api/studente/presenze-laboratorio';
  public static GET_GRUPPO_STUDIO_PRESENZE_URL = 'api/studente/presenze-aula';
  public static CREA_SESSIONE_OLA_URL = 'api/sessione-ola/crea';
  public static ELIMINA_SESSIONE_OLA_URL = 'api/sessione-ola/elimina';
  public static RIMUOVI_DOCUMENTO_SESSIONE_OLA_URL =
    'api/sessione-ola/rimuovi-documento';
  public static MODIFICA_SESSIONE_OLA_URL = 'api/sessione-ola/modifica';
  public static SESSIONI_OLA_SEARCH_URL = 'api/sessione-ola/search';
  public static GET_SESSIONE_OLA_URL = 'api/sessione-ola/get';
  public static CREA_CATEGORIA_URL = 'api/self-study/crea-category';
  public static MODIFICA_CATEGORIA_URL = 'api/self-study/modifica-category';
  public static SEARCH_CATEGORIA_URL = 'api/self-study/search-category';
  public static UPDATE_ORDINAMENTO_DOCUMENT_URL =
    'api/self-study/update-ordinamento-document';
  public static UPDATE_ORDINAMENTO_CATEGORY_URL =
    'api/self-study/update-ordinamento-category';
  public static GET_CATEGORIA_URL = 'api/self-study/get-category';
  public static CREA_PROVA_FINALE_URL = 'api/prova-finale/crea';
  public static MODIFICA_PROVA_FINALE_URL = 'api/prova-finale/modifica';
  public static ELIMINA_PROVA_FINALE_URL = 'api/prova-finale/elimina';
  public static SEARCH_PROVA_FINALE_URL = 'api/prova-finale/search';
  public static AULE_COMBO_URL = 'api/select/aule';
  public static GIORNI_SETTIMANA_COMBO_URL = 'api/select/giorni-settimana';
  public static FASCE_ORARIE_COMBO_URL = 'api/select/fasce-orarie';
  public static LANGUAGE_LEVELS_COMBO_URL = 'api/select/language-levels';
  public static DUPLICA_GRUPPO_URL = 'api/gruppo-studio/duplica';
  public static CREA_GRUPPO_STUDIO_URL = 'api/gruppo-studio/crea';
  public static MODIFICA_GRUPPO_STUDIO_URL = 'api/gruppo-studio/modifica';
  public static SEARCH_GRUPPO_STUDIO_URL = 'api/gruppo-studio/search';
  public static GENERA_GRUPPI_STUDIO_URL =
    'api/funzionalita/genera-gruppi-studio';
  public static STATISTICHE_URL =
    'api/funzionalita/statistiche';
    public static STATISTICHE_EXCEL_URL =
    'api/funzionalita/download-statistiche';
  public static SCARICA_AMMESSI_URL = 'api/funzionalita/scarica-ammessi';
  public static DOWNLOAD_STUDENTI_PLACEMENT =
    'api/funzionalita/download-studenti-placement';
  public static DOWNLOAD_ATTESTATO_STUDENTE ='api/funzionalita/download-attestato-studenti';
  public static PROVE_FINALI_COMBO_URL = 'api/select/prove-finali';
  public static CARICA_VOTI_PLACEMENT_URL =
    'api/funzionalita/carica-voti-placement';
  public static SAVE_REGISTRAZIONE_SISTEMA_URL =
    'api/registrazione-sistema/modifica';
  public static CREA_CORSO_LAUREA_URL = 'api/corso-laurea/crea';
  public static MODIFICA_CORSO_LAUREA_URL = 'api/corso-laurea/modifica';
  public static SEARCH_CORSO_LAUREA_URL = 'api/corso-laurea/search';
  public static GET_CORSO_LAUREA_URL = 'api/corso-laurea/get';
  public static ABILITA_DISABILITA_CORSO_LAUREA_URL =
    'api/corso-laurea/abilita-disabilita';
  public static ABILITA_DISABILITA_OBBLIGO_ORALE_CORSO_LAUREA_URL =
    'api/corso-laurea/abilita-disabilita-obbligo-orale';
  public static CREA_AULA_URL = 'api/aula/crea';
  public static MODIFICA_AULA_URL = 'api/aula/modifica';
  public static ELIMINA_AULA_URL = 'api/aula/elimina';
  public static SEARCH_AULA_URL = 'api/aula/search';
  public static GET_AULA_URL = 'api/aula/get';
  public static ABILITA_DISABILITA_AULA_URL = 'api/aula/abilita-disabilita';
  public static DOWNLOAD_AGENDA_STUDIO_STUDENTE =
    'api/studente/download-agenda-studio';
  public static GET_NOME_AGENDA_STUDIO_STUDENTE =
    'api/studente/get-nome-agenda-studio';
  public static APPROVA_AGENDA_STUDENTE = 'api/studente/approva-agenda';
  public static SEARCH_STUDENTI_AGENDA_URL =
    'api/studente/search-studenti-with-agenda-da-verificare';
  public static GET_GRUPPO_STUDIO_URL = 'api/gruppo-studio/get';
  public static I_MIEI_CALENDARI_GRUPPI_STUDIO_URL =
    'api/gruppo-studio/get-miei-calendari-gruppi-studio';
  public static APPELLO_GRUPPO_STUDIO_URL = 'api/gruppo-studio/appello';
  public static APPELLO_GRUPPO_STUDIO_INSTRUCTOR_URL =
    'api/gruppo-studio/appello-instructor';
  public static GET_PERCENTUALE_GRUPPO_STUDIO_URL =
    'api/gruppo-studio/percentuale-gruppo-studio';
  public static CREA_LABORATORIO_URL =
    'api/laboratorio-lezione-tutoraggio/crea';
  public static APPELLO_LABORATORIO_URL =
    'api/laboratorio-lezione-tutoraggio/appello';
  public static APPELLO_LABORATORIO_TUTOR_URL =
    'api/laboratorio-lezione-tutoraggio/appello-tutor';
  public static MODIFICA_LABORATORIO_URL =
    'api/laboratorio-lezione-tutoraggio/modifica';
  public static GET_PRENOTAZIONI_APPELLO_URL =
    'api/studente-prenotazione-laboratorio-tutoraggio/search';
  public static SEARCH_LABORATORIO_URL =
    'api/laboratorio-lezione-tutoraggio/search';
  public static GET_LABORATORIO_URL = 'api/laboratorio-lezione-tutoraggio/get';
  public static ABILITA_DISABILITA_LABORATORIO_URL =
    'api/laboratorio-lezione-tutoraggio/abilita-disabilita';
  public static ABILITA_DISABILITA_GRUPPO_STUDIO_URL =
    'api/gruppo-studio/abilita-disabilita';
  public static I_MIEI_CALENDARI_LABORATORI_URL =
    'api/laboratorio-lezione-tutoraggio/get-miei-calendari-laboratori';
  public static AULA_COMBO_URL = 'api/select/aule';
  public static GET_PROVA_FINALE_URL = 'api/prova-finale/get';
  public static ABILITA_DISABILITA_PROVA_FINALE_URL =
    'api/prova-finale/abilita-disabilita';
  public static DOWNLOAD_PRENOTATI_PROVA_FINALE =
    '/api/prenotati-prova-finale/download-prenotati-prova-finale';
  public static SEARCH_PRENOTATI_PROVA_FINALE_URL =
    '/api/prenotati-prova-finale/search';
  public static CREA_SELF_STUDY_DOCUMENT_URL =
    'api/self-study/crea-self-study-document';
  public static ELIMINA_SELF_STUDY_DOCUMENT_URL =
    'api/self-study/elimina-self-study-document';
  public static ELIMINA_SELF_STUDY_CATEGORY_URL =
    'api/self-study/elimina-self-study-category';
  public static MODIFICA_SELF_STUDY_DOCUMENT_URL =
    'api/self-study/modifica-self-study-document';
  public static SEARCH_SELF_STUDY_DOCUMENT_URL =
    'api/self-study/search-self-study-document';
  public static GET_SELF_STUDY_DOCUMENT_URL =
    'api/self-study/get-self-study-document';
  public static CATEGORIE_SELF_STUDY_COMBO_URL =
    'api/select/categorie-self-study';
  public static LOGIN_URL = 'api/login/login';
  public static MENU_UTENTE_URL = 'api/login/menu-utente';
  public static SEARCH_LOG_OPERAZIONE_URL = 'api/log-operazione/search';
}
